import React, {useState} from 'react';
import {Button, Dialog, DialogActions, DialogTitle, Typography} from '@mui/material';
import {LoadingButton} from '@mui/lab';
import IosShareIcon from '@mui/icons-material/IosShare';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import {Files, ShareLinkDialog} from 'app/components/entities/files';
import {StyleSx, Sx} from 'app/types/common';
import {packSx} from 'app/util/packSx/packSx';

const buttonSx: StyleSx = {minWidth: 98};

interface Props extends Sx {
  filename: string;
  share?: Files.Share;
  link?: string;
  onShare: () => Promise<void>;
}

export function ShareFile({sx, filename, share, link, onShare}: Props) {
  const [loading, setLoading] = useState(false);
  const [shareDialog, setShareDialog] = useState(false);
  const [confirmDialog, setConfirmDialog] = useState(false);

  const handleShare = async () => {
    try {
      setLoading(true);
      await onShare();
      setConfirmDialog(false);
      setShareDialog(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {share ? (
        <Button
          sx={packSx(buttonSx, sx)}
          variant="outlined"
          color="secondary"
          startIcon={<PeopleAltOutlinedIcon />}
          onClick={() => setShareDialog(true)}
        >
          Shared
        </Button>
      ) : (
        <Button
          sx={packSx(buttonSx, sx)}
          variant="outlined"
          color="primary"
          startIcon={<IosShareIcon />}
          onClick={() => setConfirmDialog(true)}
        >
          Share
        </Button>
      )}

      <Dialog
        open={confirmDialog}
        maxWidth="xs"
        fullWidth={true}
        onClose={() => setConfirmDialog(false)}
      >
        <DialogTitle>
          Confirm sharing file: <br />
          <Typography variant="inherit" color="primary.main">
            {filename}
          </Typography>
        </DialogTitle>

        <DialogActions>
          <LoadingButton
            data-id="share-button"
            loading={loading}
            variant="contained"
            color="primary"
            onClick={handleShare}
          >
            Share
          </LoadingButton>

          <Button
            data-id="cancel-button"
            variant="outlined"
            color="info"
            onClick={() => setConfirmDialog(false)}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      <ShareLinkDialog
        open={shareDialog}
        name={filename}
        link={link}
        share={share}
        onClose={() => setShareDialog(false)}
      />
    </>
  );
}
